import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import OurPeople from 'components/our-people';

type Props = {
  data: Object,
};

const OurPeoplePage = ({ data }: Props) => {
  const {
    peopleJson,
    getInTouchJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...peopleJson,
        getInTouch: getInTouchJson,
        cookieConsent: cookieConsentJson,
        menu: siteJson?.content,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <OurPeople />
      </Layout>
    </Website>
  );
};

export default OurPeoplePage;

export const query = graphql`
  query PeoplePageQuery {
    peopleJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
      }
      leadership {
        cards {
          id
          title
          caption
          content
          buttonLabel
          buttonLink
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        subtitle
      }
      slider {
        images {
          xl
          lg
          md
          sm
          xs
        }
      }
      meta {
        description
        title
      }
    }
    getInTouchJson {
      ...GetInTouchJsonFragment
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
